import {Purchase} from "@/entity/Purchase";

export class Subscription {
  constructor(props = {}) {
    this.id = props.id
    this.availableAt = props.availableAt
    this.expireAt = props.expireAt
    this.purchase = new Purchase(props.purchase || {})
  }
}
